const $ = window.$

export function postUpload(uploadFile, progressCallback){
  let data = new FormData()
  data.append('data', uploadFile)
  data.append('tmp', true)
  return $.ajax({
    url: window.cm.urls['attachments-api'],
    type: 'POST',
    data: data,
    xhr: function() {
      var xhr = $.ajaxSettings.xhr()
      if(xhr.upload){
        xhr.upload.addEventListener('progress', progressCallback, false)
      }
      return xhr
    },
    cache:false,
    contentType: false,
    processData: false
  })
}
